import Client from './client';

export default class Experiences extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postItemsAndFilters(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiences/items/filters`, {
      ...options,
       method: 'POST',
    });
  }

  postItemsAndFiltersByFilter(organization, filter, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiences/items/filters/${filter}`, {
      ...options,
       method: 'POST',
    });
  }

  getItemsAndQueryByExperienceKey(organization, experienceKey, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiences/${experienceKey}/items/query`, options);
  }

}
